// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"564":"b5cf058823c5e7541b27","565":"37f1f91623587a60d441","946":"531f0063f252a5f2e9db"}[chunkId] + ".chunk.js";
};